import * as React from 'react';
import { Provider } from 'mobx-react';
import { configure } from 'mobx';
import { Store } from './stores';
import { FeedAdmin } from './FeedAdmin';

export interface IFeedAdminProps {
  environment: "Development" | "Test" | "Production";
  tenant: string;
}

export class IAFeedAdmin extends React.Component<IFeedAdminProps> {

  private store: Store;

  constructor(props: IFeedAdminProps) {
    super(props);
    this.store = new Store();
    this.store.environment = props.environment;
    this.store.tenant = props.tenant;
    configure({
      isolateGlobalState: true,
      enforceActions: "never"
    });
  }

  public render(): JSX.Element {
    return (
      <Provider store={this.store}>
        <FeedAdmin />
      </Provider>
    );
  }
  
}